import { Event, Resource } from "@/db/schema";
import { atom } from "jotai";

// Event dialog atoms
export const selectedEventAtom = atom<Event | null>(null);
export const eventDialogOpenAtom = atom(false);
export const eventEditModeAtom = atom(false);

// Create event dialog atoms
export const createEventDialogOpenAtom = atom(false);
export const createEventResourceAtom = atom<Resource | null>(null);
export const createEventStartTimeAtom = atom<Date>(new Date());
export const createEventEndTimeAtom = atom<Date>(new Date());
